import * as types from 'constants/configuracionCatalogosTypes';
import * as services from 'services/configuracionCatalogos.service';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { showAlert } from 'actions/alert.actions';
import { message } from 'antd';
import { ERROR_SAVE } from 'constants/MensajesGenerales';

export const getTiposHallazgos = (payload) => async (dispatch) => {
  dispatch({ type: types.GET_LIST_CONF_CATALOGOS_LOADING });
  try {
    const response = await services.fetchCatalogosTiposHallazgos(payload);
    // console.log('actions', response.data);

    dispatch({
      type: types.GET_LIST_CONF_CATALOGOS_SUCCESS,
      success: true,
      response: response.data
    });
    return { success: true, response: response.data };
  } catch (error) {
    console.log('Error al obtener la petición', error);
    dispatch({ type: types.GET_LIST_CONF_CATALOGOS_FAILURE });
    return { success: false };
  }
};

export const updateTiposHallazgos = (payload) => async (dispatch) => {
  dispatch({ type: types.UPDATE_CONF_CATALOGOS_LOADING });
  // console.log('payload update', payload);
  try {
    const response = await services.updateCatalogosTiposHallazgos(payload);
    // console.log('update action_1', response);
    if (
      response?.tipos_hallazgos?.synced?.length === 0 ||
      response?.tipos_hallazgos?.notSyced.length > 0
    ) {
      const errorMessage = ERROR_SAVE;
      dispatch({
        type: types.UPDATE_CONF_CATALOGOS_FAILURE,
        error: { message, errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }
    dispatch({ type: types.UPDATE_CONF_CATALOGOS_SUCCESS, payload: response });
    return { success: true, response };
  } catch (error) {
    return { success: false };
  }
};
